import styled from 'styled-components';
import { H4 } from '../../common/components/Typography/Heading/Heading.styles';
import { Paragraph } from '../../common/components/Typography/Paragraph/Paragraph';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FONT_STACK, FontSize, LineHeight, FontWeight } from '../../common/styles/constants';
import { Breakpoint } from '../../common/styles/constants';

export const Container = styled.div`
  background-color: ${ThemeColours.mono100};
  padding: 0px;
`;

export const Text = styled(Paragraph)`
  color: ${ThemeColours.black};
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.LIGHT};
  margin: 0;
  padding-bottom: 16px;
`;

export const SubHeadingWrapper = styled.div`
  padding: 40px 20px;
  text-align: left;

  ${Breakpoint.MEDIUM} {
    padding: 96px 100px;
    width: 60%;
  }
`;

export const SubHeading = styled(H4)`
  font-size: ${FontSize.LARGE};
  padding-top: 40px;
  text-align: center;

  ${Breakpoint.MEDIUM} {
    padding-top: 0px;
    text-align: left;
  }
`;

export const SubText = styled.p`
  ${FONT_STACK};
  color: ${ThemeColours.mono700};
  font-size: ${FontSize.REGULAR};
  line-height: ${LineHeight.REGULAR};
  text-align: left;
`;

export const Footer = styled.div`
  align-items: center;
  background-color: ${ThemeColours.primary700};
  display: flex;
  justify-content: center;
  padding: 0px 20px 20px 20px;

  ${Breakpoint.MEDIUM} {
    padding: 0px 0px 96px 0px;
  }
`;

export const FaqButton = styled.button`
  ${FONT_STACK}
  background: none;
  border: none;
  color: ${ThemeColours.linkText};
  cursor: pointer;
  font-size: ${FontSize.REGULAR};
  line-height: ${LineHeight.REGULAR};
  padding: 0;
  text-decoration: underline;
`;
